export async function* parseSseStream(
  stream: ReadableStream<Uint8Array>
): AsyncGenerator<{ event: string; data: unknown }> {
  const reader = stream.getReader()
  const decoder = new TextDecoder()
  let buffer = ""

  const parseBlock = (raw: string): { event: string; data: unknown } | null => {
    if (raw.startsWith(":")) return null // heartbeat comment
    let event = "message"
    const dataLines: string[] = []
    for (const line of raw.split("\n")) {
      if (line.startsWith("event:")) event = line.slice(6).trim()
      else if (line.startsWith("data:")) dataLines.push(line.slice(5).trim())
    }
    if (!dataLines.length) return null
    const joined = dataLines.join("\n")
    try {
      return { event, data: JSON.parse(joined) }
    } catch {
      return { event, data: joined }
    }
  }

  try {
    while (true) {
      const { done, value } = await reader.read()
      if (done) break
      // Normalize CRLF so \r\n framing is handled the same as \n.
      buffer += decoder.decode(value, { stream: true }).replace(/\r\n/g, "\n")
      let sep: number
      while ((sep = buffer.indexOf("\n\n")) !== -1) {
        const raw = buffer.slice(0, sep)
        buffer = buffer.slice(sep + 2)
        const frame = parseBlock(raw)
        if (frame) yield frame
      }
    }
    // Flush the decoder and emit any trailing frame not terminated by a final
    // blank line, so the last event isn't dropped if the stream closes abruptly.
    buffer += decoder.decode().replace(/\r\n/g, "\n")
    const tail = buffer.trim()
    if (tail) {
      const frame = parseBlock(tail)
      if (frame) yield frame
    }
  } finally {
    await reader.cancel().catch(() => {})
  }
}
